var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title,"btnLabel":"Salvar","btnIcon":"save","btnAsEvent":"","noHeader":""},on:{"ok":_vm.submit}},[_c('Form',_vm._b({ref:"form"},'Form',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }